import { TemplateResult, html, nothing, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import innerStyles from './outline-kyruus-result-summary.inner.pcss?inline';
import globalStyles from './outline-kyruus-result-summary.global.pcss?inline';
import { AdoptedStyleSheets } from '../../../controllers/adopted-stylesheets';

/**
 * The Kyruus Result Summary Component
 * @element outline-kyruus-result-summary
 *
 * @slot filters - Slot to add filter buttons for the search results
 * @slot summary - Slot to add a summary of the search results
 * @slot sort - Slot to add sorting controls for the search results
 *
 * @todo replace screen size controller with container queries
 * @todo update slot manager to do.... something.
 *
 */
@customElement('outline-kyruus-result-summary')
export class OutlineKyruusResultSummary extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: innerStyles,
  });

  @property({ type: String, reflect: true }) screenSize: 'mobile' | 'desktop';

  render(): TemplateResult {
    // Provide mobile and desktop template versions, toggle them in CSS.
    return html`
      <div class="wrapper wrapper-mobile">
        ${this.slotTemplate('filters')} ${this.slotTemplate('summary')}
        ${this.slotTemplate('sort')}
      </div>

      <div class="wrapper wrapper-desktop">
        ${this.querySelector('[slot="summary"]') ||
        this.querySelector('[slot="sort"]')
          ? html` <div class="summary-sort-wrapper">
              ${this.slotTemplate('summary')} ${this.slotTemplate('sort')}
            </div>`
          : nothing}
        ${this.slotTemplate('filters')}
      </div>
    `;
  }

  slotTemplate(slotName: string) {
    if (!this.querySelector(`[slot=${slotName}]`)) {
      return nothing;
    } else {
      return html`<slot name="${slotName}"></slot>`;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-kyruus-result-summary': OutlineKyruusResultSummary;
  }
}
